"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.query = exports.getReviewOptions = exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _grid = require("@rebass/grid");
var _client = require("@apollo/client");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ContentWrapper = _interopRequireDefault(require("./ContentWrapper"));
var _LeaveBookingReview = _interopRequireDefault(require("./LeaveBookingReview"));
var _Page = require("./Page");
var _ReadReview = _interopRequireDefault(require("./ReadReview"));
var _LeaveActivityReview = _interopRequireDefault(require("./LeaveActivityReview"));
var _reactIntl = require("react-intl");
var _normalizeReviewData = require("../utils/normalizeReviewData");
const _excluded = ["data"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const query = exports.query = (0, _client.gql)`
    fragment ReviewModal on OrderItem {
        ... on Booking {
            id
            review {
                ...Review
            }
            rentalUnit {
                id
                flexCancellationDays
                reviewStats {
                    ...ReviewStats
                }
                accommodation {
                    id
                    ownerName
                    jpegOwner: ownerImage {
                        transform(config: AVATAR, format: JPEG) {
                            ...Transform
                        }
                    }
                    webpOwner: ownerImage {
                        transform(config: AVATAR, format: WEBP) {
                            ...Transform
                        }
                    }
                }
            }
        }
        ... on Ticket {
            id
            activityReview {
                ...ActivityReview
            }
            activity{
                activityReviewStats{
                    ...ActivityReviewStats
                }
            }
        }
        ...OrderSummaryItem
    }

    mutation LeaveReview($input: LeaveReviewInput!) {
        leaveReview(input: $input) {
            review {
                ...Review
            }
        }
    }

    mutation LeaveActivityReview($input: LeaveActivityReviewInput!) {
        leaveActivityReview(input: $input) {
            activityReview {
                ...ActivityReview
            }
        }
    }

    fragment Review on Review {
        id
        average
        comment
        date
        ratingHospitality
        ratingLayout
        ratingLocation
        ratingMaintenance
        ratingValueForMoney
        tips
        title
        travelGroupType
        reply
    }

    fragment ActivityReview on ActivityReview {
        id
        title
        average
        comment
        date
        ratingHospitality
        ratingActivity
        ratingValueForMoney
        tips
        reply
    }
`;
const reviewMessages = (0, _reactIntl.defineMessages)({
  '10': {
    "id": "7ebrDm",
    "defaultMessage": [{
      "type": 0,
      "value": "10. Uitmuntend"
    }]
  },
  '9': {
    "id": "E4OO49",
    "defaultMessage": [{
      "type": 0,
      "value": "9. Fantastisch"
    }]
  },
  '8': {
    "id": "6Vub1M",
    "defaultMessage": [{
      "type": 0,
      "value": "8. Erg goed"
    }]
  },
  '7': {
    "id": "Ib1UHU",
    "defaultMessage": [{
      "type": 0,
      "value": "7. Goed"
    }]
  },
  '6': {
    "id": "Tu5zXb",
    "defaultMessage": [{
      "type": 0,
      "value": "6. Voldoende"
    }]
  },
  '5': {
    "id": "q7aEfp",
    "defaultMessage": [{
      "type": 0,
      "value": "5. Matig"
    }]
  },
  '4': {
    "id": "ZTFLDr",
    "defaultMessage": [{
      "type": 0,
      "value": "4. Zeer matig"
    }]
  },
  '3': {
    "id": "lJe3Ji",
    "defaultMessage": [{
      "type": 0,
      "value": "3. Slecht"
    }]
  },
  '2': {
    "id": "AtGZfx",
    "defaultMessage": [{
      "type": 0,
      "value": "2. Zeer slecht"
    }]
  },
  '1': {
    "id": "Z4Uryo",
    "defaultMessage": [{
      "type": 0,
      "value": "1. Verschikkelijk"
    }]
  }
});
const getReviewOptions = intl => Object.keys(reviewMessages).reverse().map(key => ({
  value: Number(key),
  label: intl.formatMessage(reviewMessages[key])
}));
exports.getReviewOptions = getReviewOptions;
const ReviewModal = _ref => {
  let {
      data
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // used to see if we just left a review so we can show the "thank you for you review" part
  const normalizedData = (0, _normalizeReviewData.normalizeReviewData)(data);
  const {
    0: leftReview,
    1: setLeftReview
  } = (0, _react.useState)(normalizedData?.review ? null : false);
  const item = normalizedData?.item;
  if (!normalizedData || !item) {
    return null;
  }
  return __jsx(StyledModal, props, __jsx(ModalWrapper, null, __jsx(Content, null, typeof leftReview === 'boolean' && __jsx(_react.default.Fragment, null, item.__typename === 'Booking' && __jsx(_LeaveBookingReview.default, {
    booking: item,
    leftReview: leftReview,
    setLeftReview: setLeftReview
  }), item.__typename === 'Ticket' && __jsx(_LeaveActivityReview.default, {
    ticket: item,
    activity: normalizedData.activity,
    leftReview: leftReview,
    setLeftReview: setLeftReview
  })), typeof leftReview !== 'boolean' && __jsx(_ReadReview.default, {
    data: normalizedData
  }))));
};
const StyledModal = (0, _styledComponents.default)(_Modal.default).withConfig({
  displayName: "ReviewModal__StyledModal",
  componentId: "vewvcb-0"
})(["", " [data-reach-dialog-content]{padding:0;display:flex;justify-content:center;}"], _Page.wrapperPadding);
const ModalWrapper = (0, _styledComponents.default)(_ContentWrapper.default).withConfig({
  displayName: "ReviewModal__ModalWrapper",
  componentId: "vewvcb-1"
})(["flex-direction:column;display:flex;min-height:90vh;width:100%;"]);
const Content = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "ReviewModal__Content",
  componentId: "vewvcb-2"
})(["width:100%;padding:", " 0;@media screen and (min-width:", "){padding:", " 0;}"], ({
  theme
}) => theme.spacing['50_Semi'], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.spacing['80_XXLarge']);
var _default = exports.default = ReviewModal;